export default __webpack_public_path__ + "static/media/error-big.78fa0aee.svg";